<template>
  <v-dialog :value="display" max-width="540" persistent @input="!$event && $emit('close')">
    <v-card>
      <v-card-title>
        {{ $t(`ticket_name.title.${edit ? 'edit' : 'create'}`) }}
      </v-card-title>
      <v-divider />

      <v-card-text class="pt-5">
        <v-form ref="form" v-model="formValid">

          <v-text-field
            v-model="form.name"
            ref="nameInput"
            :label="$t('label.name')"
            :rules="[v => !!v || $t('validation.required')]"
            outlined
            dense
            class="mb-1"
            @keyup.enter="submitForm"
          />

          <v-text-field
            v-model="form.group_name"
            :label="$t('ticket_name.label.group')"
            :placeholder="$t('ticket_name.label.group_placeholder')"
            :hint="$t('ticket_name.label.group_hint')"
            persistent-hint
            outlined
            dense
            class="mb-3"
          />

          <v-text-field
            v-model.number="form.sort_order"
            :label="$t('ticket_name.label.sort_order')"
            type="number"
            min="0"
            outlined
            dense
            class="mb-1"
          />

          <template v-if="!edit">
            <v-select
              v-model="form.store_id"
              :items="stores"
              item-text="name"
              item-value="id"
              :label="$t('ticket_name.label.store')"
              :rules="form.apply_to_all ? [] : [v => !!v || $t('validation.required')]"
              :disabled="form.apply_to_all"
              outlined
              dense
              class="mb-1"
            />
            <v-checkbox
              v-model="form.apply_to_all"
              :label="$t('ticket_name.label.apply_to_all')"
              dense
              hide-details
              class="mt-0"
            />
            <p class="caption grey--text mt-1 mb-0">{{ $t('ticket_name.label.apply_to_all_hint') }}</p>
          </template>

        </v-form>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('close')">{{ $t('button.cancel') }}</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!submittable"
          @click="submitForm"
        >
          {{ $t(`ticket_name.button.${edit ? 'update' : 'create'}`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CreateEditTicketName',

  props: {
    display: { type: Boolean, required: true },
    ticket_name: { type: Object, default: () => ({}) },
    stores: { type: Array, default: () => [] }
  },

  data () {
    return {
      form: { name: '', group_name: '', store_id: null, sort_order: 0, apply_to_all: false },
      formValid: false,
      loading: false
    }
  },

  computed: {
    edit () {
      return !!this.ticket_name.id
    },
    submittable () {
      return !!this.form.name && (this.edit || this.form.apply_to_all || !!this.form.store_id)
    }
  },

  watch: {
    display (val) {
      if (!val) return
      this.form = { name: '', group_name: '', store_id: null, sort_order: 0, apply_to_all: false }
      this.loading = false
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetValidation()
        if (this.edit) {
          this.form.name = this.ticket_name.name || ''
          this.form.group_name = this.ticket_name.group_name || ''
          this.form.sort_order = this.ticket_name.sort_order || 0
        }
        this.$refs.nameInput && this.$refs.nameInput.focus()
      })
    }
  },

  methods: {
    async submitForm () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      try {
        let data
        if (this.edit) {
          data = await this.$ticketNameService.update(this.ticket_name.id, {
            name: this.form.name,
            group_name: this.form.group_name || null,
            sort_order: this.form.sort_order
          })
        } else {
          data = await this.$ticketNameService.create({
            name: this.form.name,
            group_name: this.form.group_name || null,
            sort_order: this.form.sort_order,
            apply_to_all: this.form.apply_to_all,
            store_id: this.form.apply_to_all ? null : this.form.store_id
          })
        }
        this.$emit('saved', data)
      } catch (e) {
        console.error('submitForm', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
